// src/services/api.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Products API
export const getProducts = () => api.get('/products');
export const createProduct = (data) => api.post('/products', data);
export const updateProduct = (id, data) => api.put(`/products/${id}`, data);
export const deleteProduct = (id) => api.delete(`/products/${id}`);

// Fridge API
export const createFridge = (data) => api.post('/fridges', data);
export const getFridges = () => api.get('/fridges');
export const getFridgeById = (fridgeId) => api.get(`/fridges/${fridgeId}`);
export const updateFridge = (fridgeId, data) => api.put(`/fridges/${fridgeId}`, data);
export const deleteFridge = (fridgeId) => api.delete(`/fridges/${fridgeId}`);

// Fridge Products API
export const assignProduct = (data) => api.post('/fridges/assign-product', data);
export const getFridgeProducts = (fridgeId) => api.get(`/fridges/${fridgeId}/products`);
export const getLowStockFridges = () => api.get('/fridges/low-stock');

// Apartments API
export const getApartments = () => api.get('/apartments');
export const createApartment = (data) => api.post('/apartments', data);

// QR Fridge API (Customer facing)
export const scanFridge = (fridgeId) => api.get(`/fridge/scan/${fridgeId}`);
export const fridgeCheckout = (data) => api.post('/fridge/checkout', data);

// Customer API
export const registerCustomer = (data) => api.post('/customer/register', data);
export const getCustomer = (customerId) => api.get(`/customer/${customerId}`);
export const getCustomerByEmail = (email) => api.get(`/customer/email/${email}`);
export const updateCustomer = (customerId, data) => api.put(`/customer/${customerId}`, data);
export const getCustomerOrders = (customerId) => api.get(`/customer/${customerId}/orders`);
export const customerCheckout = (data) => api.post('/customer/checkout', data);

// Orders/Sales API
export const getDailySales = (date) => api.get('/sales/daily', { params: { date } });

export default api;